export const API_URL = "https://www.bt1.lv/balticbeauty/things/models/products.php";
export const TIMEOUT_SEC = 10;
export const FINALISTS_CATEGORIES = [58, 59, 60];
